import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { BORROWER_DETAIL_STALE_MS, borrowerDetailQueryOptions } from "./borrowerDetailQueryOptions";

export function useBorrowerQuery(borrowerId: number | string | null) {
  const id = borrowerId != null ? Number(borrowerId) : null;
  const opts = id != null ? borrowerDetailQueryOptions(id) : null;
  return useQuery({
    queryKey: opts?.queryKey ?? queryKeys.borrower(null),
    queryFn: opts?.queryFn ?? (() => Promise.reject(new Error("No borrower ID"))),
    enabled: id != null,
    staleTime: BORROWER_DETAIL_STALE_MS,
  });
}
